/**
 * A bearer credential for API requests made from a page served without a session.
 *
 * The API mutator sends the session token when there is one; otherwise it sends whatever a
 * route registered here. The route that decides a page is public (and knows where its
 * credential comes from — a signed link, say) is the one that registers it, so this layer holds
 * no knowledge of any feature. It is consulted only when there is no session token, so a value
 * left behind by a page the visitor navigated away from is inert: every other admin route
 * redirects to login without a session, and once signed in the session token wins.
 */
let bearerTokenOverride: string | null = null;

export const setBearerTokenOverride = (token: string | null): void => {
  bearerTokenOverride = token;
};

export const getBearerTokenOverride = (): string | null => bearerTokenOverride;
